/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

const CRITICAL_JOBS_DATA = "criticalJobsData";
const BAR_PANEL_DATA = "barPanelData";
const CENTER_GRAPH = "centerGraph";

module.exports = {
    CRITICAL_JOBS_DATA,
    BAR_PANEL_DATA,
    CENTER_GRAPH,
}